import {
  consultationConsultationEntitySchemaV1,
  design_systemUiEventEventSchemaV1,
  experimentationFeatureFlagsEntitySchemaV1,
  pmsPrescriptionProductEntitySchemaV2,
} from '@montugroup/data-collection';
import type { z } from 'zod';

/**
 * Registering a new analytics context:
 *
 * 1. Import the schema from `@montugroup/data-collection`
 * 2. Add the schema to the `contextSchemas` object below.
 *    - The key you use here (e.g., `consultation`, `flags`) will be used when referencing this context
 *      inside `AnalyticsTrackingProvider` and emitted events.
 *
 * Example:
 * ```ts
 * import { myCustomContextEntitySchemaV1 } from '@montugroup/data-collection';
 *
 * export const contextSchemas = {
 *   ...,
 *   myContextKey: myCustomContextEntitySchemaV1
 * } as const;
 * ```
 *
 * The `TypedAnalyticsContexts` type infers the correct structure
 * based on your schema.
 */

export const contextSchemas = {
  consultation: consultationConsultationEntitySchemaV1,
  flags: experimentationFeatureFlagsEntitySchemaV1,
  uiEvent: design_systemUiEventEventSchemaV1.pick({ context_id: true }),
  prescriptionProduct: pmsPrescriptionProductEntitySchemaV2,
} as const;

export type ContextKey = keyof typeof contextSchemas;

export type TypedAnalyticsContexts = {
  [K in ContextKey]?: z.infer<(typeof contextSchemas)[K]>;
};
